import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { WebSocketContext } from "../../context/WebSocketContext";
import { GeneralContext } from "../../context/GeneralContext";
import { api } from "../../utils/authActions";
import { DataGrid } from "@mui/x-data-grid";
import SettingsIcon from "@mui/icons-material/Settings";
import Modal from "react-modal";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import EditUser from "../../components/adminComponents/EditUser";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./profilePages.scss";
import AnswerEntry from "../../components/adminComponents/polling/AnswerEntry";
import { deepCopy } from "../../components/leftSide/Models/modelLogic";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { isActive, hasProperty } from "../../utils/helpers";
import ConfirmationScreen from "../../components/commonComponents/ConfirmationScreen";
import PollWithAnswers from "../../components/adminComponents/polling/PollWithAnswers";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Chip from "@mui/material/Chip";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs-plugin-utc";
//import toast from "react-hot-toast";

dayjs.extend(dayjsPluginUTC);

function AdminPage() {
  const navigate = useNavigate();
  const { authToken, isAuthReady, isAdmin, packages } = useContext(AuthContext);
  const { sendJsonMessage } = useContext(WebSocketContext);
  const { recordedErrorLog } = useContext(GeneralContext);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [value, setValue] = useState("users");
  const [newQuestion, setNewQuestion] = useState("");
  const [newAnswers, setNewAnswers] = useState(["", ""]);
  const [activePolls, setActivePolls] = useState([]);
  const [closedPolls, setClosedPolls] = useState([]);
  const [message, setMessage] = useState("");
  const [confirmMessageOpen, setConfirmMessageOpen] = useState(false);
  const [noEnd, setNoEnd] = useState(false);
  const [noStart, setNoStart] = useState(false);
  const [startDate, setStartDate] = useState(dayjs().add(2, "hour"));
  const [endDate, setEndDate] = useState(dayjs().add(5, "day"));
  // News state variables
  const [newNewsTitle, setNewNewsTitle] = useState("");
  const [newNewsContent, setNewNewsContent] = useState("");
  const [newNewsCreationDate, setNewNewsCreationDate] = useState(dayjs());
  const [newNewsEndDate, setNewNewsEndDate] = useState(dayjs().add(30, "day"));
  const [newNewsNoEnd, setNewNewsNoEnd] = useState(true);
  const [newNewsHidden, setNewNewsHidden] = useState(false);
  const [newNewsType, setNewNewsType] = useState("");
  // Edit news state variables
  const [editNewsNumMessages, setEditNewsNumMessages] = useState(10);
  const [editNewsIncludeHidden, setEditNewsIncludeHidden] = useState(true);
  const [editNewsIncludeOld, setEditNewsIncludeOld] = useState(true);
  const [editNewsType, setEditNewsType] = useState("");
  const [fetchedNews, setFetchedNews] = useState([]);
  // Edit modal state variables
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [editNewsTitle, setEditNewsTitle] = useState("");
  const [editNewsContent, setEditNewsContent] = useState("");
  const [editNewsCreationDate, setEditNewsCreationDate] = useState(dayjs());
  const [editNewsEndDate, setEditNewsEndDate] = useState(
    dayjs().add(30, "day")
  );
  const [editNewsNoEnd, setEditNewsNoEnd] = useState(true);
  const [editNewsHidden, setEditNewsHidden] = useState(false);
  const [editNewsTypeModal, setEditNewsTypeModal] = useState("");

  // User filtering state
  const [newsletterFilter, setNewsletterFilter] = useState(-1); // -1: all, 0: false, 1: true
  const [includePackages, setIncludePackages] = useState([]);
  const [excludePackages, setExcludePackages] = useState([]);
  const [expiredPackages, setExpiredPackages] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);

  const tableRef = useRef();
  const messageRef = useRef();

  useEffect(() => {
    if (isAuthReady) {
      // Check admin status before making any API calls
      if (authToken === "" || !isAdmin) {
        navigate("/profile");
        return;
      }

      // admin: get all polls
      api
        .getAllPolls(authToken)
        .then((response) => {
          const activePolls = [];
          const closedPolls = [];

          for (let i = 0; i < response.data.length; i++) {
            const singlePoll = response.data[i];

            if (isActive(singlePoll.closing_date)) {
              activePolls.push(singlePoll);
            } else {
              closedPolls.push(singlePoll);
            }
          }

          setActivePolls(activePolls);
          setClosedPolls(closedPolls);
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          recordedErrorLog(
            `THERE WAS AN ERROR WITH POLL RETRIEVAL: ${errorDetails}`,
            err,
            true,
            "Unexpected error occurred retrieving all polls. Check console log for more details."
          );
        });
    }
  }, [isAuthReady, authToken, isAdmin, navigate]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const columns = [
    {
      field: "selected",
      headerName: "",
      width: 20,
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Checkbox
          checked={params.row.selected === true}
          onChange={(e) => {
            handleUserSelectionToggle(params.id, e.target.checked);
          }}
          size="small"
        />
      ),
    },
    { field: "id", headerName: "ID", width: 40 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "full_name", headerName: "Full name", width: 130 },
    { field: "affiliation", headerName: "Affiliation", width: 130 },
    { field: "academic_verified", headerName: "Academic", width: 80 },
    {
      field: "created_on",
      headerName: "Created on",
      width: 120,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
    },
    {
      field: "last_login",
      headerName: "Last login",
      width: 120,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
    },
    { field: "is_superuser", headerName: "Admin", width: 60 },
    { field: "newsletter", headerName: "Newsletter", width: 80 },
    {
      field: "edit",
      headerName: "Edit",
      width: 60,
      renderCell: (params) => (
        <SettingsIcon
          style={{ cursor: "pointer" }}
          onClick={() => {
            setSelectedUser(params.id);
            setEditOpen(true);
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    try {
      const rowsToSet = users.map((user) => {
        // let dateObj = new Date(user.created_on);

        // let day = String(dateObj.getDate()).padStart(2, "0");
        // let month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Note: 0 = January, so we must add 1 to get correct month
        // let year = dateObj.getFullYear();

        // let newDateString = day + "/" + month + "/" + year;

        // return {
        //   id: user.id,
        //   email: user.email,
        //   email_confirmed: user.email_confirmed,
        //   full_name: user.full_name,
        //   affiliation: user.affiliation,
        //   is_superuser: user.is_superuser,
        //   created_on: newDateString,
        //   newsletter: user.newsletter,
        // };
        return {
          id: user.id,
          email: user.email,
          full_name: user.full_name,
          affiliation: user.affiliation,
          academic_verified: user.academic_verified,
          is_superuser: user.is_superuser,
          created_on: user.created_on, // Keep the raw date or ISO string here
          last_login: user.last_login,
          newsletter: user.newsletter,
          selected: user.selected || false, // Include the selected property
        };
      });

      setRows(rowsToSet);
    } catch (error) {
      recordedErrorLog("Users useEffect has failed: ", error);
    }
  }, [users]);

  useEffect(() => {
    try {
      if (isAuthReady && authToken !== "" && isAdmin) {
        setIsTableLoading(true);
        // admin: get all users
        api
          .getUsers(authToken)
          .then((response) => {
            // Set all users as selected by default
            const usersWithSelection = response.data.map((user) => ({
              ...user,
              selected: true,
            }));
            setUsers(usersWithSelection);
          })
          .catch((err) => {
            const errorDetails = hasProperty(err, "response")
              ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
              : "No backend response available";
            recordedErrorLog(
              `THERE WAS AN ERROR WITH LOADING USERS IN ADMIN: ${errorDetails}`,
              err,
              true,
              "Unexpected error occurred retrieving users. Check console log for more details."
            );
          })
          .finally(() => {
            setIsTableLoading(false);
          });
      }
    } catch (error) {
      recordedErrorLog("'isAuthReady' useEffect has failed: ", error);
    }
  }, [isAuthReady]);

  const handleCloseEditModal = () => {
    setEditOpen(false);
  };

  const handleAnswerChange = (val, index) => {
    try {
      const newAnswersArray = deepCopy(newAnswers);
      newAnswersArray[index] = val;
      setNewAnswers(newAnswersArray);
    } catch (error) {
      recordedErrorLog("Answer change handler has failed: ", error);
    }
  };

  const handleDeleteAnswer = (index) => {
    try {
      const newAnswersArray = deepCopy(newAnswers);
      newAnswersArray.splice(index, 1);
      setNewAnswers(newAnswersArray);
    } catch (error) {
      recordedErrorLog("Answer delete handler has failed: ", error);
    }
  };

  const handleAddNewAnswer = () => {
    setNewAnswers((old) => [...old, ""]);
  };

  const handleCreatePoll = () => {
    try {
      const clearedAnswers = newAnswers.filter((answer) => answer !== "");
      if (
        clearedAnswers.length >= 2 &&
        newQuestion !== "" &&
        startDate.isBefore(endDate)
      ) {
        const payloadForPoll = {
          question: newQuestion,
          answers: clearedAnswers,
        };

        if (!noStart) {
          payloadForPoll.starting_date = startDate.utc().toISOString();
        }

        if (!noEnd) {
          payloadForPoll.closing_date = endDate.utc().toISOString();
        }

        api
          // admin: create new poll
          .createNewPoll(authToken, payloadForPoll)
          .then((response) => {
            const newPoll = response.data;
            setActivePolls((old) => [...old, newPoll]);
            setNewQuestion("");
            setNewAnswers(["", ""]);
          })
          .catch((err) => {
            const errorDetails = hasProperty(err, "response")
              ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
              : "No backend response available";
            recordedErrorLog(
              `THERE WAS AN ERROR WITH POLL CREATION: ${errorDetails}`,
              err,
              true,
              "Unexpected error occurred creating the poll. Check console log for more details."
            );
          });
      }
    } catch (error) {
      recordedErrorLog("Create poll handler has failed: ", error);
    }
  };

  const handleGlobalMessageSend = () => {
    setConfirmMessageOpen(true);
  };

  const handleConfirmMessageSend = () => {
    const payload = {
      Broadcast: message,
    };

    try {
      sendJsonMessage(payload, false);
    } catch (error) {
      const errorDetails = hasProperty(error, "response")
        ? `Backend response: ${JSON.stringify(error.response, null, 2)}`
        : "No backend response available";
      recordedErrorLog(
        `THERE WAS AN ERROR WITH GLOBAL MESSAGE SEND: ${errorDetails}`,
        error,
        true,
        "Unexpected error occurred sending the global message. Please try again or contact support."
      );
    }

    setMessage("");
    setConfirmMessageOpen(false);
  };

  const handleDeletePoll = (id, active) => {
    try {
      if (active) {
        const clearedActive = activePolls.filter((poll) => poll.id !== id);
        setActivePolls(clearedActive);
      } else {
        const clearedClosed = closedPolls.filter((poll) => poll.id !== id);
        setClosedPolls(clearedClosed);
      }
    } catch (error) {
      recordedErrorLog("Delete poll handler has failed: ", error);
    }
  };

  const handlePollUpdate = () => {
    api
      // admin: get all polls
      .getAllPolls(authToken)
      .then((response) => {
        const activePolls = [];
        const closedPolls = [];

        for (let i = 0; i < response.data.length; i++) {
          const singlePoll = response.data[i];

          if (isActive(singlePoll.closing_date)) {
            activePolls.push(singlePoll);
          } else {
            closedPolls.push(singlePoll);
          }
        }

        setActivePolls(activePolls);
        setClosedPolls(closedPolls);
      })
      .catch((err) => {
        const errorDetails = err.response
          ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
          : "No backend response available";
        recordedErrorLog(
          `THERE WAS AN ERROR WITH POLL RETRIEVAL: ${errorDetails}`,
          err,
          true,
          "Could not retrieve all polls. Check console for more info."
        );
      });
  };

  const handleUserDelete = (userId) => {
    try {
      const updatedUsers = users.filter((user) => user.id !== userId);
      setUsers(updatedUsers);
      setEditOpen(false);
    } catch (error) {
      recordedErrorLog("User delete handler has failed: ", error);
    }
  };

  const handleFilterUsers = async () => {
    try {
      setIsFiltering(true);

      const params = {
        skip: 0,
        limit: 1000,
        user_selection_request: {
          newsletter: newsletterFilter,
          include_packages: includePackages,
          exclude_packages: excludePackages,
          inactive_packages: expiredPackages,
        },
      };

      const response = await api.getUsersWithConditions(authToken, params);

      // Update the main users list and rows for display, setting all as selected by default
      const usersWithSelection = response.data.map((user) => ({
        ...user,
        selected: true,
      }));
      setUsers(usersWithSelection);
    } catch (error) {
      const errorDetails = hasProperty(error, "response")
        ? `Backend response: ${JSON.stringify(error.response, null, 2)}`
        : "No backend response available";
      recordedErrorLog(
        `THERE WAS AN ERROR FILTERING USERS: ${errorDetails}`,
        error,
        true,
        "Unexpected error occurred filtering users. Please try again later, or contact support."
      );
    } finally {
      setIsFiltering(false);
    }
  };

  const handleClearFilters = () => {
    setNewsletterFilter(-1);
    setIncludePackages([]);
    setExcludePackages([]);
    setExpiredPackages([]);
  };

  const handleSelectAll = () => {
    setUsers((prevUsers) =>
      prevUsers.map((user) => ({ ...user, selected: true }))
    );
  };

  const handleUnselectAll = () => {
    setUsers((prevUsers) =>
      prevUsers.map((user) => ({ ...user, selected: false }))
    );
  };

  const handleCreateEmailList = () => {
    const selectedUsers = users.filter((user) => user.selected);
    if (selectedUsers.length === 0) {
      alert(
        "No users selected. Please select at least one user to create an email list."
      );
      return;
    }

    // Create email list in Outlook-friendly format (semicolon-separated)
    const emailList = selectedUsers.map((user) => user.email).join("; ");

    // Copy to clipboard
    navigator.clipboard
      .writeText(emailList)
      .then(() => {
        alert(
          `Email list copied to clipboard!\n\n${selectedUsers.length} email addresses:\n${emailList}`
        );
      })
      .catch((err) => {
        console.error("Failed to copy email list:", err);
        // Fallback: show the email list in a prompt for manual copying
        prompt("Email list (copy manually):", emailList);
      });
  };

  const handleUserSelectionToggle = (userId, isSelected) => {
    try {
      // Update the user in the local state
      setUsers((prevUsers) => {
        const updatedUsers = prevUsers.map((user) =>
          user.id === userId ? { ...user, selected: isSelected } : user
        );
        return updatedUsers;
      });

      // TODO: Add API call to update user's selected status on backend
      // await api.updateUserSelected(authToken, userId, isSelected);
    } catch (error) {
      recordedErrorLog("User selection toggle handler has failed: ", error);
    }
  };

  const handleCreateNews = () => {
    try {
      const payload = {
        title: newNewsTitle,
        content: newNewsContent,
        creation_date: newNewsCreationDate.toISOString(),
        end_date: newNewsNoEnd ? null : newNewsEndDate.toISOString(),
        hidden: newNewsHidden,
        newstype: newNewsType || null,
      };

      api
        .createNewsMessage(authToken, payload)
        .then(() => {
          // Reset form
          setNewNewsTitle("");
          setNewNewsContent("");
          setNewNewsType("");
          setNewNewsCreationDate(dayjs());
          setNewNewsEndDate(dayjs().add(30, "day"));
          setNewNewsNoEnd(true);
          setNewNewsHidden(false);

          // TODO: Refresh news list after creation
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          recordedErrorLog(
            `THERE WAS AN ERROR CREATING NEWS: ${errorDetails}`,
            err,
            true,
            "Unexpected error occurred creating news. Please try again later, or contact support."
          );
        });
    } catch (error) {
      recordedErrorLog("News creation handler has failed: ", error);
    }
  };

  const handleFetchNews = () => {
    try {
      const params = {
        num_messages: editNewsNumMessages,
        include_hidden: editNewsIncludeHidden,
        include_old: editNewsIncludeOld,
        newstype: editNewsType || undefined,
      };

      api
        .getLastNewsMessages(authToken, params)
        .then((response) => {
          setFetchedNews(response.data);
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          recordedErrorLog(
            `THERE WAS AN ERROR FETCHING NEWS: ${errorDetails}`,
            err,
            true,
            "Unexpected error occurred fetching news. Please try again later, or contact support."
          );
        });
    } catch (error) {
      recordedErrorLog("News fetch handler has failed: ", error);
    }
  };

  const handleEditNews = (news) => {
    try {
      setSelectedNews(news);
      setEditNewsTitle(news.title);
      setEditNewsContent(news.content);
      setEditNewsCreationDate(dayjs(news.creation_date));
      setEditNewsEndDate(
        news.end_date ? dayjs(news.end_date) : dayjs().add(30, "day")
      );
      setEditNewsNoEnd(!news.end_date);
      setEditNewsHidden(news.hidden);
      setEditNewsTypeModal(news.newstype || "");
      setEditModalOpen(true);
    } catch (error) {
      recordedErrorLog("Edit news handler has failed: ", error);
    }
  };

  const handleUpdateNews = () => {
    try {
      const payload = {
        id: selectedNews.id,
        title: editNewsTitle,
        content: editNewsContent,
        creation_date: editNewsCreationDate.toISOString(),
        end_date: editNewsNoEnd ? null : editNewsEndDate.toISOString(),
        hidden: editNewsHidden,
        newstype: editNewsTypeModal || null,
      };

      api
        .updateNewsMessage(authToken, payload)
        .then(() => {
          setEditModalOpen(false);
          // Refresh the news list
          handleFetchNews();
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          recordedErrorLog(
            `THERE WAS AN ERROR UPDATING NEWS: ${errorDetails}`,
            err,
            true,
            "Unexpected error occurred updating news. Please try again later, or contact support."
          );
        });
    } catch (error) {
      recordedErrorLog("News update handler has failed: ", error);
    }
  };

  const handleDeleteNews = () => {
    try {
      api
        .deleteNewsMessage(authToken, selectedNews.id)
        .then(() => {
          setEditModalOpen(false);
          // Refresh the news list
          handleFetchNews();
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          recordedErrorLog(
            `THERE WAS AN ERROR DELETING NEWS: ${errorDetails}`,
            err,
            true,
            "Unexpected error occurred deleting news. Please try again later, or contact support."
          );
        });
    } catch (error) {
      recordedErrorLog("News delete handler has failed: ", error);
    }
  };

  return (
    <div className="adminPage">
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Users" value="users" />
            <Tab label="Polls" value="polls" />
            <Tab label="News" value="news" />
            <Tab label="Extras" value="extras" />
          </TabList>
        </Box>
        <TabPanel value="users" className="usersTabArea">
          <div className="usersTableSection">
            <div className="usersTableTitle">Search Users:</div>

            {/* User Filtering Section */}
            <div
              className="userFilterSection"
              style={{
                marginBottom: "20px",
                padding: "15px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <div
                className="filterTitle"
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                }}
              >
                Filter Users:
              </div>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "15px",
                  alignItems: "center",
                }}
              >
                {/* Newsletter Filter */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "150px",
                  }}
                >
                  <label style={{ fontSize: "14px", marginBottom: "5px" }}>
                    Newsletter:
                  </label>
                  <Select
                    value={newsletterFilter}
                    onChange={(e) => setNewsletterFilter(e.target.value)}
                    size="small"
                    style={{ minWidth: "120px" }}
                  >
                    <MenuItem value={-1}>All</MenuItem>
                    <MenuItem value={0}>No Newsletter</MenuItem>
                    <MenuItem value={1}>Newsletter</MenuItem>
                  </Select>
                </div>

                {/* Include Packages */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "200px",
                  }}
                >
                  <label style={{ fontSize: "14px", marginBottom: "5px" }}>
                    Include Packages:
                  </label>
                  <Select
                    multiple
                    value={includePackages}
                    onChange={(e) => setIncludePackages(e.target.value)}
                    size="small"
                    style={{ minWidth: "180px" }}
                    renderValue={(selected) => (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "2px",
                        }}
                      >
                        {selected.map((value) => {
                          const packageName =
                            packages.find((pkg) => pkg.id === value)?.name ||
                            `Package ${value}`;
                          return (
                            <Chip
                              key={value}
                              label={packageName}
                              size="small"
                            />
                          );
                        })}
                      </div>
                    )}
                  >
                    {packages.map((pkg) => (
                      <MenuItem key={pkg.id} value={pkg.id}>
                        {pkg.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                {/* Exclude Packages */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "200px",
                  }}
                >
                  <label style={{ fontSize: "14px", marginBottom: "5px" }}>
                    Exclude Packages:
                  </label>
                  <Select
                    multiple
                    value={excludePackages}
                    onChange={(e) => setExcludePackages(e.target.value)}
                    size="small"
                    style={{ minWidth: "180px" }}
                    renderValue={(selected) => (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "2px",
                        }}
                      >
                        {selected.map((value) => {
                          const packageName =
                            packages.find((pkg) => pkg.id === value)?.name ||
                            `Package ${value}`;
                          return (
                            <Chip
                              key={value}
                              label={packageName}
                              size="small"
                            />
                          );
                        })}
                      </div>
                    )}
                  >
                    {packages.map((pkg) => (
                      <MenuItem key={pkg.id} value={pkg.id}>
                        {pkg.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                {/* Expired Packages */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "200px",
                  }}
                >
                  <label style={{ fontSize: "14px", marginBottom: "5px" }}>
                    Expired Packages:
                  </label>
                  <Select
                    multiple
                    value={expiredPackages}
                    onChange={(e) => setExpiredPackages(e.target.value)}
                    size="small"
                    style={{ minWidth: "180px" }}
                    renderValue={(selected) => (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "2px",
                        }}
                      >
                        {selected.map((value) => {
                          const packageName =
                            packages.find((pkg) => pkg.id === value)?.name ||
                            `Package ${value}`;
                          return (
                            <Chip
                              key={value}
                              label={packageName}
                              size="small"
                            />
                          );
                        })}
                      </div>
                    )}
                  >
                    {packages.map((pkg) => (
                      <MenuItem key={pkg.id} value={pkg.id}>
                        {pkg.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>

              {/* Filter Buttons */}
              <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                <Button
                  variant="contained"
                  onClick={handleFilterUsers}
                  disabled={isFiltering}
                  size="small"
                >
                  {isFiltering ? "Filtering..." : "Apply Filters"}
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  size="small"
                >
                  Clear Filters
                </Button>
              </div>
            </div>

            <div className="usersTableSearchArea">
              <TextField
                className="usersTableSearch"
                placeholder="Search users"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <FilterAltIcon className="filter" />
            </div>
            <div className="usersTableContainer" ref={tableRef}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 20 },
                  },
                }}
                pageSizeOptions={[5, 10, 20, 50, 100]}
                sx={{
                  "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                    outline: "none !important",
                  },
                }}
                loading={isTableLoading}
              />

              {/* Selection Control Buttons */}
              <div
                style={{
                  marginTop: "15px",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                  }}
                >
                  User Selection:
                </div>
                <div
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <Button
                    variant="contained"
                    onClick={handleSelectAll}
                    size="small"
                    color="primary"
                  >
                    Select All
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleUnselectAll}
                    size="small"
                  >
                    Unselect All
                  </Button>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      marginLeft: "10px",
                    }}
                  >
                    {users.filter((user) => user.selected).length} of{" "}
                    {users.length} users selected
                  </span>
                  <Button
                    variant="contained"
                    onClick={handleCreateEmailList}
                    size="small"
                    color="primary"
                    disabled={
                      users.filter((user) => user.selected).length === 0
                    }
                  >
                    Create Email List
                  </Button>
                </div>
              </div>

              <Modal
                isOpen={editOpen}
                onRequestClose={handleCloseEditModal}
                shouldCloseOnOverlayClick={true}
                contentLabel="Fit Modal"
                appElement={tableRef.current}
                style={{
                  content: {
                    top: "35%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    marginRight: "-50%",
                    transform: "translate(-50%, -35%)",
                    minWidth: "440px",
                    width: "80vw",
                    minHeight: "650px",
                    height: "70vh",
                  },
                  overlay: {
                    zIndex: "100",
                  },
                }}
              >
                <EditUser
                  userData={users.find((user) => user.id === selectedUser)}
                  handleUserDelete={handleUserDelete}
                />
              </Modal>
            </div>
          </div>
        </TabPanel>
        <TabPanel value="polls" className="pollsTabArea">
          <div className="pollingSection">
            <div className="pollingTitle">Polls:</div>
            <div className="newPoll">
              <div className="pollTitle">Create new poll:</div>
              <TextField
                className="newQuestionEntry"
                size="small"
                value={newQuestion}
                onChange={(e) => setNewQuestion(e.target.value)}
                label="New poll question"
              />
              <div className="answers">
                {newAnswers.map((answer, index) => {
                  return (
                    <AnswerEntry
                      key={index}
                      value={answer}
                      setValue={handleAnswerChange}
                      index={index}
                      deleteAnswer={handleDeleteAnswer}
                    />
                  );
                })}
              </div>
              <div className="addAnswerArea">
                <div
                  className="addAnswerButton"
                  onClick={() => handleAddNewAnswer()}
                >
                  <AddIcon />
                  <div className="addText">Add answer</div>
                </div>
              </div>
              <div className="durationArea">
                <div className="duration">
                  <div className="title">Starting date:</div>
                  <div className="checkboxArea">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={noStart}
                            onChange={() => setNoStart((old) => !old)}
                          />
                        }
                        label={"Poll has no start date"}
                      />
                    </FormGroup>
                  </div>
                  <div className={`time`}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date"
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        disabled={noStart}
                        minDate={dayjs()}
                      />
                      <TimePicker
                        label="Time"
                        className="timeSelector"
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        disabled={noStart}
                        // minTime={
                        //   startDate?.isSame(dayjs(), "day")
                        //     ? dayjs()
                        //     : undefined
                        // }
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="duration">
                  <div className="title">End date:</div>
                  <div className="checkboxArea">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={noEnd}
                            onChange={() => setNoEnd((old) => !old)}
                          />
                        }
                        label={"Poll has no end date"}
                      />
                    </FormGroup>
                  </div>
                  <div className={`time`}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date"
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        disabled={noEnd}
                        minDate={startDate || dayjs()}
                      />
                      <TimePicker
                        label="Time"
                        className="timeSelector"
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        disabled={noEnd}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
              <div className="createPollButtonArea">
                <Button
                  variant="contained"
                  className="createButton"
                  onClick={() => handleCreatePoll()}
                  id="create-poll-button-admin"
                >
                  Create Poll
                </Button>
              </div>
            </div>
            <div className="divider" />
            <div className="pollingTitle">Active Polls:</div>
            <div className="activePollArea">
              {activePolls.length > 0 ? (
                <div className="polls">
                  {activePolls.map((poll) => {
                    return (
                      <div className="singlePoll" key={poll.id}>
                        <PollWithAnswers
                          active
                          start={poll.starting_date}
                          end={poll.closing_date}
                          pollId={poll.id}
                          question={poll.question}
                          answers={poll.answers}
                          handleDeletePoll={handleDeletePoll}
                          handlePollUpdate={handlePollUpdate}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="noActive">No active polls</div>
              )}
            </div>
            <div className="pollingTitle">Closed Polls:</div>
            <div className="activePollArea">
              {closedPolls.length > 0 ? (
                <div className="polls">
                  {closedPolls.map((poll) => {
                    return (
                      <div className="singlePoll" key={poll.id}>
                        <PollWithAnswers
                          start={poll.starting_date}
                          end={poll.closing_date}
                          pollId={poll.id}
                          question={poll.question}
                          answers={poll.answers}
                          handleDeletePoll={handleDeletePoll}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="noActive">No closed polls</div>
              )}
            </div>
          </div>
        </TabPanel>
        <TabPanel value="news" className="newsTabArea">
          <div className="pollingSection">
            <div className="pollingTitle">News:</div>
            <div className="newPoll">
              <div className="pollTitle">Create new news:</div>
              <TextField
                className="newQuestionEntry"
                size="small"
                value={newNewsTitle}
                onChange={(e) => setNewNewsTitle(e.target.value)}
                label="News title"
              />
              <TextField
                className="newQuestionEntry"
                size="small"
                value={newNewsContent}
                onChange={(e) => setNewNewsContent(e.target.value)}
                label="News content"
                multiline
                rows={4}
                style={{ marginTop: "10px" }}
              />
              <TextField
                className="newQuestionEntry"
                size="small"
                value={newNewsType}
                onChange={(e) => setNewNewsType(e.target.value)}
                label="News type (optional)"
                style={{ marginTop: "10px" }}
              />
              <div className="durationArea">
                <div className="duration">
                  <div className="title">Creation date:</div>
                  <div className="checkboxArea">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={newNewsHidden}
                            onChange={() => setNewNewsHidden((old) => !old)}
                          />
                        }
                        label="Hidden (not visible to users)"
                      />
                    </FormGroup>
                  </div>
                  <div className={`time`}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date"
                        value={newNewsCreationDate}
                        onChange={(newValue) =>
                          setNewNewsCreationDate(newValue)
                        }
                        minDate={dayjs()}
                      />
                      <TimePicker
                        label="Time"
                        className="timeSelector"
                        value={newNewsCreationDate}
                        onChange={(newValue) =>
                          setNewNewsCreationDate(newValue)
                        }
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="duration">
                  <div className="title">End date:</div>
                  <div className="checkboxArea">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={newNewsNoEnd}
                            onChange={() => setNewNewsNoEnd((old) => !old)}
                          />
                        }
                        label={"News has no end date"}
                      />
                    </FormGroup>
                  </div>
                  <div className={`time`}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date"
                        value={newNewsEndDate}
                        onChange={(newValue) => setNewNewsEndDate(newValue)}
                        disabled={newNewsNoEnd}
                        minDate={newNewsCreationDate}
                      />
                      <TimePicker
                        label="Time"
                        className="timeSelector"
                        value={newNewsEndDate}
                        onChange={(newValue) => setNewNewsEndDate(newValue)}
                        disabled={newNewsNoEnd}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
              <div className="createPollButtonArea">
                <Button
                  variant="contained"
                  className="createButton"
                  id="create-news-button-admin"
                  onClick={() => handleCreateNews()}
                  disabled={!newNewsTitle.trim() || !newNewsContent.trim()}
                >
                  Create News
                </Button>
              </div>
            </div>
            <div className="divider" />
            <div className="newPoll">
              <div className="pollTitle">Edit News:</div>
              <div className="durationArea">
                <div className="duration">
                  <div className="title">Number of messages:</div>
                  <TextField
                    className="newQuestionEntry"
                    size="small"
                    value={editNewsNumMessages}
                    onChange={(e) =>
                      setEditNewsNumMessages(parseInt(e.target.value) || 10)
                    }
                    label="Number of messages"
                    type="number"
                    inputProps={{ min: 1, max: 100 }}
                    style={{ width: "120px" }}
                  />
                </div>
                <div className="duration">
                  <div className="title">News type filter:</div>
                  <TextField
                    className="newQuestionEntry"
                    size="small"
                    value={editNewsType}
                    onChange={(e) => setEditNewsType(e.target.value)}
                    label="News type (optional)"
                  />
                </div>
              </div>
              <div className="checkboxArea">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editNewsIncludeHidden}
                        onChange={() => setEditNewsIncludeHidden((old) => !old)}
                      />
                    }
                    label="Include hidden news"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editNewsIncludeOld}
                        onChange={() => setEditNewsIncludeOld((old) => !old)}
                      />
                    }
                    label="Include old news"
                  />
                </FormGroup>
              </div>
              <div className="createPollButtonArea">
                <Button
                  variant="contained"
                  className="createButton"
                  id="fetch-news-button-admin"
                  onClick={() => handleFetchNews()}
                >
                  Get News
                </Button>
              </div>
            </div>
            {fetchedNews.length > 0 && (
              <>
                <div className="divider" />
                <div className="pollingTitle">
                  Fetched News ({fetchedNews.length} items):
                </div>
                <div className="activePollArea">
                  <div className="polls">
                    {fetchedNews.map((news, index) => (
                      <div key={index} className="singlePoll">
                        <div
                          className="newsItem"
                          onClick={() => handleEditNews(news)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="newsItemTitle">
                            {news.creation_date} - {news.title}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </TabPanel>
        <TabPanel value="extras" className="extrasTabArea">
          <div className="extrasArea">
            <div className="globalMessage" ref={messageRef}>
              <div className="title">Message for all active users:</div>
              <textarea
                placeholder="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <div className="buttonArea">
                <Button
                  variant="contained"
                  className="sendButton"
                  onClick={() => handleGlobalMessageSend()}
                  disabled={!message.trim()}
                >
                  Send Message
                </Button>
              </div>
            </div>
          </div>
          <ConfirmationScreen
            onYes={handleConfirmMessageSend}
            onNo={() => setConfirmMessageOpen(false)}
            text={
              "Are you sure you want to send this message to ALL ACTIVE USERS?"
            }
            open={confirmMessageOpen}
            setOpen={setConfirmMessageOpen}
            element={messageRef}
          />
        </TabPanel>
      </TabContext>

      {/* Edit News Modal */}
      <Modal
        isOpen={editModalOpen}
        onRequestClose={() => setEditModalOpen(false)}
        shouldCloseOnOverlayClick={true}
        contentLabel="Edit News Modal"
        appElement={document.getElementById("root")}
        style={{
          content: {
            width: "600px",
            height: "80vh",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            zIndex: "9999",
          },
          overlay: {
            zIndex: "9999",
          },
        }}
      >
        <div className="newPoll">
          <div className="pollTitle">Edit News:</div>
          <TextField
            className="newQuestionEntry"
            size="small"
            value={editNewsTitle}
            onChange={(e) => setEditNewsTitle(e.target.value)}
            label="News title"
            fullWidth
          />
          <TextField
            className="newQuestionEntry"
            size="small"
            value={editNewsContent}
            onChange={(e) => setEditNewsContent(e.target.value)}
            label="News content"
            multiline
            rows={4}
            fullWidth
            style={{ marginTop: "10px" }}
          />
          <TextField
            className="newQuestionEntry"
            size="small"
            value={editNewsTypeModal}
            onChange={(e) => setEditNewsTypeModal(e.target.value)}
            label="News type (optional)"
            fullWidth
            style={{ marginTop: "10px" }}
          />
          <div className="durationArea">
            <div className="duration">
              <div className="title">Creation date:</div>
              <div className="time">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date"
                    value={editNewsCreationDate}
                    onChange={(newValue) => setEditNewsCreationDate(newValue)}
                    minDate={dayjs()}
                  />
                  <TimePicker
                    label="Time"
                    className="timeSelector"
                    value={editNewsCreationDate}
                    onChange={(newValue) => setEditNewsCreationDate(newValue)}
                  />
                </LocalizationProvider>
              </div>
            </div>
            <div className="duration">
              <div className="title">End date:</div>
              <div className="checkboxArea">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editNewsNoEnd}
                        onChange={() => setEditNewsNoEnd((old) => !old)}
                      />
                    }
                    label={"News has no end date"}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editNewsHidden}
                        onChange={() => setEditNewsHidden((old) => !old)}
                      />
                    }
                    label="Hidden (not visible to users)"
                  />
                </FormGroup>
              </div>
              <div className="time">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date"
                    value={editNewsEndDate}
                    onChange={(newValue) => setEditNewsEndDate(newValue)}
                    disabled={editNewsNoEnd}
                    minDate={editNewsCreationDate}
                  />
                  <TimePicker
                    label="Time"
                    className="timeSelector"
                    value={editNewsEndDate}
                    onChange={(newValue) => setEditNewsEndDate(newValue)}
                    disabled={editNewsNoEnd}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>
          <div className="createPollButtonArea">
            <Button
              variant="contained"
              className="createButton"
              onClick={() => handleUpdateNews()}
              disabled={!editNewsTitle.trim() || !editNewsContent.trim()}
              style={{ marginRight: "10px" }}
            >
              Update News
            </Button>
            <Button
              variant="contained"
              color="error"
              className="createButton"
              onClick={() => handleDeleteNews()}
            >
              Delete News
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AdminPage;
